// eslint-disable-next-line @typescript-eslint/ban-types
export class RequestError extends Error {
	name = 'RequestError';
	statusText = '';
	statusCode = 0;
	constructor(statusText: string, statusCode = 0) {
		super(`${statusText} (${statusCode})`);
		this.statusText = statusText;
		this.statusCode = statusCode;
	}
}
export class GraphQLFetchError extends RequestError {
	constructor(statusText = '', statusCode = 0) {
		super(statusText, statusCode);
		this.name = 'GraphQLFetchError';
	}
}

export class ForbiddenError extends RequestError {
	constructor(statusText = '') {
		super(statusText, 403);
		this.name = 'ForbiddenError';
	}
}

export class UnauthorizedError extends RequestError {
	constructor(statusText = '') {
		super(statusText, 401);
		this.name = 'UnauthorizedError';
	}
}

export class BadRequestError extends RequestError {
	constructor(statusText = '', statusCode = 400) {
		super(statusText, statusCode);
		this.name = 'BadRequestError';
	}
}

export class NotFound extends RequestError {
	constructor(statusText = '') {
		super(statusText, 404);
		this.name = 'NotFound';
	}
}

export class InternalServerError extends RequestError {
	constructor(statusText = '') {
		super(statusText, 500);
		this.name = 'InternalServerError';
	}
}

export class RelayRequiredFieldError extends RequestError {
	name = 'RelayRequiredFieldError';
}
